import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

const getCompletedReviews = async () => {
  const response = await fetchWrapper(hcUrlV3('/reviews'), buildOpts());
  return handleResponse(response);
};

export { getCompletedReviews };
